module.exports = __webpack_public_path__ + "frontend-assets/img/leaderboard_icon.69ad823c.png";